import React from 'react'
import { Form } from 'react-bootstrap'

import { WithCapabilitiesWrapper } from 'src/enhancers/with_capabilities'
import { getConstants } from 'src/lib/constants'
import getCapsGroups, { requiredModules } from './caps_groups'
import styles from './caps_renderer.module.css'

class CapsRenderer extends React.Component {
  static defaultProps = {
    caps: [],
    handleChange: () => {},
  }

  tCaps = getConstants().t_caps

  nullHandler = () => null

  renderCaps = (start, stop) => {
    let { caps, handleChange } = this.props
    let _caps = Object.keys(this.tCaps).slice(start, stop + 1)

    let items = []
    for (let c of _caps) {
      items.push(
        <WithCapabilitiesWrapper key={c} required_modules={requiredModules?.[c] ?? []}>
          <tr
            className={styles.row_hover}
            onClick={() => {
              handleChange(c, !caps[c])
            }}>
            <td>{this.tCaps[c]}</td>
            <td className="text-end">
              <Form.Check type="checkbox" id={c} name={c} checked={caps[c] === true} onChange={this.nullHandler} />
            </td>
          </tr>
        </WithCapabilitiesWrapper>
      )
    }
    return items
  }

  render() {
    return getCapsGroups().map(group => {
      return (
        <WithCapabilitiesWrapper key={`cap_group_${group.name}`} required_modules={group?.required_modules ?? []}>
          <table className="table w-100">
            <thead>
              <tr>
                <th className="w-90">{group.name}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>{this.renderCaps(group.start, group.stop)}</tbody>
          </table>
        </WithCapabilitiesWrapper>
      )
    })
  }
}

export default CapsRenderer
